// Admin Constants - Centralized exports for admin-related constants

export * from './colors';
export * from './adminNavigation';
export * from './dataTable';
export * from './emptyMessages';
export * from './desktop';
export * from './organizationFormDefaults';
export * from './propertyFormDefaults';
export * from './fileUpload';

// User Types Enum
export const USER_TYPES = {
  1: 'Admin',
  2: 'Resident', 
  3: 'Staff',
} as const;